<!-- @format -->
@let reviewCount = reviewCount$ | async;
@let highlyRatedForFeatures = highlyRatedForFeatures$ | async;
@if (reviewCount > 0 && highlyRatedForFeatures?.length > 0) {
	<div class="hmf-display-flex hmf-body-m"
		[ngClass]="{'hmf-display-m-block hmf-display-xlg-flex': template() === 'out-of-stock'}">
		<span class="highly-rated-for-label">Customer Highlighted</span>
		<span hmf-action-text
			variant="secondary"
			size="medium"
			class="hmf-pl-xxxs hmf-mb-s"
			[ngClass]="{'hmf-display-lg-block hmf-display-xlg-flex hmf-pl-m-0 hmf-pl-xlg-xxxs': template() === 'out-of-stock'}"
			(click)="openModal()">
			@for (item of highlyRatedForFeatures; track $index; let last = $last) {
				{{ item.feature | titlecase }}{{ !last ? '&emsp13;•&hairsp;' : '' }}
			}
		</span>
	</div>
}
